import { render, staticRenderFns } from "./GlobalTitle.vue?vue&type=template&id=0e4ee8cb&scoped=true"
import script from "./GlobalTitle.vue?vue&type=script&lang=ts"
export * from "./GlobalTitle.vue?vue&type=script&lang=ts"
import style0 from "./GlobalTitle.vue?vue&type=style&index=0&id=0e4ee8cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4ee8cb",
  null
  
)

export default component.exports